__turbopack_context__.v({
  "browse": "FileUpload-module__AUl9KW__browse",
  "disabled": "FileUpload-module__AUl9KW__disabled",
  "dragging": "FileUpload-module__AUl9KW__dragging",
  "dropIcon": "FileUpload-module__AUl9KW__dropIcon",
  "dropText": "FileUpload-module__AUl9KW__dropText",
  "dropzone": "FileUpload-module__AUl9KW__dropzone",
  "error": "FileUpload-module__AUl9KW__error",
  "hint": "FileUpload-module__AUl9KW__hint",
  "invalid": "FileUpload-module__AUl9KW__invalid",
  "item": "FileUpload-module__AUl9KW__item",
  "itemIcon": "FileUpload-module__AUl9KW__itemIcon",
  "itemName": "FileUpload-module__AUl9KW__itemName",
  "itemSize": "FileUpload-module__AUl9KW__itemSize",
  "labelRow": "FileUpload-module__AUl9KW__labelRow",
  "list": "FileUpload-module__AUl9KW__list",
  "nativeInput": "FileUpload-module__AUl9KW__nativeInput",
  "optional": "FileUpload-module__AUl9KW__optional",
  "pasteHint": "FileUpload-module__AUl9KW__pasteHint",
  "removeBtn": "FileUpload-module__AUl9KW__removeBtn",
  "required": "FileUpload-module__AUl9KW__required",
  "root": "FileUpload-module__AUl9KW__root",
});
